import api from './base'

export default {
  getAll ({ childCompanyId }) {
    return api().get(`company/child_companies/${childCompanyId}/business_units`)
  },
  getById ({ childCompanyId, businessUnitId }) {
    return api().get(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}`)
  },
  save ({ childCompanyId, item }) {
    return api().put(`company/child_companies/${childCompanyId}/business_units`, item)
  },
  delete ({ childCompanyId, businessUnitId }) {
    return api().delete(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}`)
  },
  toggleRegistered ({ childCompanyId, data }) {
    return api().put(`company/child_companies/${childCompanyId}/business_unit_registration`, data)
  },
  setHeader ({ childCompanyId, businessUnitId, header }) {
    return api().put(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/invoice_header`, { data: header })
  },
  getHeader ({ childCompanyId, businessUnitId }) {
    return api().get(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/invoice_header`)
  },
  setFooter ({ childCompanyId, businessUnitId, footer }) {
    return api().put(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/invoice_footer`, { data: footer })
  },
  getFooter ({ childCompanyId, businessUnitId }) {
    return api().get(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/invoice_footer`)
  },
  sourceBusinessUnits ({ childCompanyId }) {
    return api().get(`company/child_companies/${childCompanyId}/available_source_business_units`)
  }
}
